import { notUndefinedOrNull } from "@tm/utils"
import { useEditCustomItem } from "../../hooks"
import { editCustomArticleItem } from "../editCustomArticleItem"
import { CustomArticleItemResponse } from "../models"
import { QUERY_KEY_ARTICLES } from "./keys"

export function useEditCustomArticleItem() {
    return useEditCustomItem(QUERY_KEY_ARTICLES, editCustomArticleItem, (response, _, prevData: CustomArticleItemResponse[]) =>
        prevData
            .map((x) => {
                if (response && x.id === response?.editedCustomArticleItem.id) {
                    if (response.editedCustomArticleItem.customArticleListId !== x.customArticleListId) {
                        return
                    }
                    return response.editedCustomArticleItem
                }
                return x
            })
            .filter(notUndefinedOrNull)
    )
}
